import React from "react";

import PropTypes from "prop-types";

import StickyBar from "./StickyBar";

// StandardStickyBar enforces standard stickybar and action button layout
export default function StandardStickyBar({
  breadcrumbs,
  actions,
  children,
  className,
  ...rest
}) {
  return (
    <StickyBar
      className={`p-4 justify-between items-center ${className || ""}`}
      {...rest}
    >
      {breadcrumbs}
      <div className="flex gap-3">{actions}</div>
      {children}
    </StickyBar>
  );
}

StandardStickyBar.propTypes = {
  breadcrumbs: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node,
  className: PropTypes.string,
};
